import { Icon } from "@iconify/react";
import React from "react";

export default function ContactInfoWidget() {
  return (
    <ul className="cs_contact_widget space-y-4">
      
      {/* Address */}
      <li className="flex items-start gap-3">
        <i className="cs_accent_bg">
          <Icon icon="ep:location" />
        </i>
        <a
          href="https://www.google.com/maps/place/National+Healthcare+%26+Wellness+Mission/"
          rel="noopener noreferrer"
          target="_blank"
          className="leading-snug"
        >
          Karbi Namghar Path, Borbari, Guwahati
        </a>
      </li>

      {/* Phone Numbers */}
      <li className="flex items-start gap-3">
        <i className="cs_accent_bg">
          <Icon icon="fluent:call-24-regular" />
        </i>

        {/* BEAUTIFUL PHONE LIST */}
        <div className="flex flex-col gap-1">
          <a
            href="tel:+913614516663"
            className="transition"
          >
            +91 3614516663 (Call)
          </a>
          <a
            href="tel:+919707076232"
            className="transition"
          >
            +91 9707076232 (WA & Call)
          </a>
          <a
            href="tel:+919707998887"
            className="transition"
          >
            +91 9707998887 (WA & Call)
          </a>
        </div>
      </li>

      {/* Email */}
      <li className="flex items-start gap-3">
        <i className="cs_accent_bg">
          <Icon icon="bi:envelope" />
        </i>
        <a
          href="mailto:nhwm.info@gmail.com"
          rel="noopener noreferrer"
          target="_blank"
        >
          info@nhwm.in
        </a>
      </li>
    </ul>
  );
}
